// extracted by mini-css-extract-plugin
export var button = "Podcast-module--button--kWYgG";
export var headline = "Podcast-module--headline--+5VlX";
export var name = "Podcast-module--name---CYHk";
export var podcastByLine = "Podcast-module--podcastByLine--brse3";
export var podcastDuration = "Podcast-module--podcastDuration--LF1YH";
export var podcastInfo = "Podcast-module--podcastInfo--uAvwk";
export var podcastIntro = "Podcast-module--podcastIntro--EO-t-";
export var podcastPlayer = "Podcast-module--podcastPlayer--syeMB";
export var podcastPlayerWrapper = "Podcast-module--podcastPlayerWrapper--QN-m2";
export var root = "Podcast-module--root--x3xjW";
export var share = "Podcast-module--share--8DTTv";
export var spacer = "Podcast-module--spacer--kl4Pc";
export var subscribe = "Podcast-module--subscribe--HjK14";